if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.variantSelects = this.querySelector("variant-radios");
        this.submitButton = this.querySelector('[type="submit"]');
        this.init();
      }

      init() {
        if (!this.variantSelects) return;
        this.variantSelects.addEventListener("change", () => {
          var rand = Math.floor(Math.random() * 1000000 + 1);
          document.querySelectorAll(".js-vimeo").forEach((video) => {
            const src = video.src;
            video.src = src + "?rand=" + rand;
          });
        });
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        this.refreshPromoMessage();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
          this.refreshPromoMessage();
        });
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
          this.refreshPromoMessage();
        });
        this._onQuantityChange = () => this.refreshPromoMessage();
        document.addEventListener('quantity:change', this._onQuantityChange, { passive: true });
                // Also refresh when the cart is updated anywhere on the site
        this._onCartEvents = () => this.refreshPromoMessage();
        ['cart:updated', 'cart:change', 'cart:refresh', 'cart:requestComplete'].forEach((evt) => {
          document.addEventListener(evt, this._onCartEvents, { passive: true });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
        if (this.quantityUpdateUnsubscriber) {
          this.quantityUpdateUnsubscriber();
        }
        if (this._onQuantityChange) {
          document.removeEventListener('quantity:change', this._onQuantityChange);
        }
                if (this._onCartEvents) {
          ['cart:updated', 'cart:change', 'cart:refresh', 'cart:requestComplete'].forEach((evt) => {
            document.removeEventListener(evt, this._onCartEvents);
          });
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      getPromoContainers() {
        return Array.from(document.querySelectorAll('.promo-progress'));
      }

      getPromoTiersFromDom(container) {
        try {
          const raw = container?.dataset?.tiers || '[]';
          const tiers = JSON.parse(raw) || [];
          return this.normalizeTiers(tiers);
        } catch (e) {
          return [];
        }
      } 
      
      parseDiscountTiers(rawTiers) {
        return (rawTiers || [])
          .map((t) => {
            const required = Number(t.quantityRequiredForDiscount);
            const discount = t.percentualDiscount != null ? Number(t.percentualDiscount) : null;
            if (Number.isNaN(required) || required <= 0) return null;
            if (discount === null || Number.isNaN(discount) || discount <= 0) return null;
            return { required, discount, type: 'discount' };
          })
          .filter(Boolean)
          .sort((a, b) => a.required - b.required);
      }

      parseGiftTiers(rawTiers) {
        return (rawTiers || [])
          .map((t) => {
            const required = Number(t.quantityRequiredToBeGifted);
            const gifted = t.quantityToBeGifted != null ? Number(t.quantityToBeGifted) : 1;
            if (Number.isNaN(required) || required <= 0) return null;
            const safeGifted = !Number.isNaN(gifted) && gifted > 0 ? gifted : 1;
            return { required, gifted: safeGifted, type: 'gift' };
          })
          .filter(Boolean)
          .sort((a, b) => a.required - b.required);
      }

      normalizeTiers(rawTiers) {
        const discountTiers = this.parseDiscountTiers(rawTiers);
        if (discountTiers.length) return discountTiers;
        return this.parseGiftTiers(rawTiers);
      }

      isDiscountMode(promotionTiers) {
        return promotionTiers?.some((t) => t.type === 'discount' && (t.discount || 0) > 0) || false;
      }

      computeDiscountMessage(currentQuantity, tiers) {
        if (!tiers?.length) return '';
        let nextEligibleTier = null;
        let highestUnlockedTier = null;
        for (let i = 0; i < tiers.length; i++) {
          const tier = tiers[i];
          if (currentQuantity < tier.required && !nextEligibleTier) nextEligibleTier = tier;
          if (currentQuantity >= tier.required) highestUnlockedTier = tier;
        }
        if (nextEligibleTier) {
          const missing = nextEligibleTier.required - currentQuantity;
          const pct = Math.round(Number(nextEligibleTier.discount || 0));
          return `Adicione mais ${missing} unidade${missing !== 1 ? 's' : ''} para desbloquear ${pct}% OFF`;
        }
        if (highestUnlockedTier && (highestUnlockedTier.discount || 0) > 0) {
          const pct = Math.round(Number(highestUnlockedTier.discount || 0));
          return `Você já desbloqueou a promoção máxima (${pct}% OFF)`;
        }
        return '';
      }

      computeGiftMessage(currentQuantity, tiers) {
        if (!tiers?.length) return '';
        let nextEligibleTier = null;
        let highestUnlockedTier = null;
        for (let i = 0; i < tiers.length; i++) {
          const tier = tiers[i];
          if (currentQuantity < tier.required && !nextEligibleTier) nextEligibleTier = tier;
          if (currentQuantity >= tier.required) highestUnlockedTier = tier;
        }
        if (nextEligibleTier) {
          const missing = nextEligibleTier.required - currentQuantity;
          const giftedLabel = nextEligibleTier.gifted === 1 ? 'uma' : String(nextEligibleTier.gifted);
          return `Adicione mais ${missing} unidade${missing !== 1 ? 's' : ''} e ganhe ${giftedLabel} de graça`;
        }
        if (highestUnlockedTier && (highestUnlockedTier.gifted || 0) > 0) {
          const giftedLabel = highestUnlockedTier.gifted === 1 ? 'uma' : String(highestUnlockedTier.gifted);
          return `Você já desbloqueou a promoção máxima (${giftedLabel} grátis)`;
        }
        return '';
      }

      computePromoMessage(currentQuantity, promotionTiers) {
        if (!promotionTiers || !promotionTiers.length) return '';
        const isDiscount = this.isDiscountMode(promotionTiers);
        return isDiscount
          ? this.computeDiscountMessage(currentQuantity, promotionTiers)
          : this.computeGiftMessage(currentQuantity, promotionTiers);
      }

      getCurrentProductId(container) {
        const pid = container?.dataset?.productId;
        return pid ? parseInt(pid, 10) : null;
      }

      refreshPromoMessage() {
        const containers = this.getPromoContainers();
        if (!containers || !containers.length) return;

        containers.forEach((container) => {
          const tiers = this.getPromoTiersFromDom(container);
          const pid = this.getCurrentProductId(container);

          fetch('/cart.js', {
            headers: { 'Accept': 'application/json', 'Cache-Control': 'max-age=5' },
            credentials: 'same-origin'
          })
            .then(r => r.json())
            .then(data => {
              const count = !pid || !Array.isArray(data?.items)
                ? 0
                : data.items
                    .filter(i => parseInt(i.product_id, 10) === pid)
                    .reduce((sum, i) => sum + (parseInt(i.quantity, 10) || 0), 0);

              const msg = this.computePromoMessage(count, tiers);
              if (msg) container.textContent = msg;
            })
            .catch(() => {});
        });
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden");
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, "text/html");
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
            this.refreshPromoMessage();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = [".quantity__input", ".quantity__rules", ".quantity__label"];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = ["data-cart-quantity", "data-min", "data-max", "step"];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
        this.refreshPromoMessage();
      }
    },
  );
}